// Import.
var crypto = require('crypto'); // Constants.


var HASH_ALGORITHM_MD5 = 'md5';
var HASH_DIGEST_HEX = 'hex';
var DEFAULT_DATA = '';
var DEFAULT_SALT = '';
var DEFAULT_ASYNC_INDICATOR = false;
/**
 * Hash data by MD5 algorithm.
 * @param {string} data Data to hash.
 * @returns {string} Hash string.
 */

function md5(data) {
  return crypto.createHash(HASH_ALGORITHM_MD5).update(data).digest(HASH_DIGEST_HEX);
}
/**
 * Hash data using salt.
 * @param {string} data Data to hash.
 * @param {string} [salt] Salt.
 * @param {boolean} [isAsync] Is async indicator. Promise returned if this parameter defined as true.
 * @returns {string|Promise<string>} Salted MD5 hash.
 */


function hash() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_DATA;
  var salt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_SALT;
  var isAsync = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_ASYNC_INDICATOR;
  // Define salted data.
  var saltedData = data + salt; // Return hash promise if async indicator setted.

  if (isAsync) {
    return new Promise(function (resolve) {
      return resolve(md5(saltedData));
    });
  } // Return hash in other cases.


  return md5(saltedData);
} // Export.


module.exports = hash;